









































import { defineComponent, ref, onMounted, useContext } from '@nuxtjs/composition-api'
import isEmpty from 'lodash/fp/isEmpty'

import { useProductStore } from '~/store/product'
import { usePdpStore } from '~/store/pdp'

import { usePDPNavigationObserver } from '~/composables/pdp/usePDPNavigationObserver'
import { COMPONENTS_IN_NAVIGATION, PRODUCT_STATUS } from '@/common/utils/product/constants'
import ProductIncludes from '~/components/feature/PDP/ProductIncludes.vue'
import RelatedProducts from '~/components/feature/PDP/RelatedProducts.vue'
import Conjugates from '~/components/feature/PDP/Conjugates.vue'
import usePDPAnalytics from '@/composables/analytics/usePDPAnalytics'
import { PDPTemplateComponent } from '~/modules/contentstack/pdpTemplateParser'

export default defineComponent({
  components: {
    ProductIncludes,
    RelatedProducts,
    Conjugates,
  },
  props: {
    productListComponents: {
      type: Array as () => PDPTemplateComponent[],
      required: false,
      default: () => [],
    },
  },
  setup({ productListComponents }) {
    const ctx = useContext()
    const isPreviewServer = ctx.$config.cst.isPreview
    const { currentProduct, getProductIncludesData } = useProductStore()
    const pdpStore = usePdpStore()
    const { trackProductListImpressions } = usePDPAnalytics()
    const customProductIncludes = pdpStore.pdpPages[currentProduct.data.key]
    let productIncludesData = {} as any
    let productListTitle = productListComponents.map((item) => item.args.title)

    if (productListComponents.length) {
      productListComponents.forEach((data) => {
        if (data.name === 'ProductIncludes') {
          productIncludesData = {
            data: getProductIncludesData(currentProduct.data.key, data.args.tableColumns),
            param: [data.args.showNotesSection, data.args.showLineBorderBetweenKitComponents],
          }

          if (!productIncludesData.data?.value) {
            productListTitle = productListTitle.filter((title) => {
              return title !== 'Product Includes'
            })
          }
        }
      })
    }

    const productIncludesDisplayCondition = ref(
      !isEmpty(productIncludesData.data?.value) || !isEmpty(customProductIncludes)
    )
    const activeProductListTab = ref(productListTitle[0])

    const onTabChange = (event: any) => {
      pdpStore.switchProductListComponents(
        getComponentInNavFromOnName(activeProductListTab.value).DISPLAY_NAME,
        getComponentInNavFromOnName(event.target.getAttribute('data-tab'))
      )
      activeProductListTab.value = event.target.getAttribute('data-tab')
    }

    const getComponentInNavFromOnName = (name: 'Related Products' | 'Conjugates' | 'Product Includes') => {
      switch (name) {
        case COMPONENTS_IN_NAVIGATION.PRODUCT_INCLUDES.DISPLAY_NAME: {
          return COMPONENTS_IN_NAVIGATION.PRODUCT_INCLUDES
        }
        case COMPONENTS_IN_NAVIGATION.RELATED_PRODUCTS.DISPLAY_NAME: {
          return COMPONENTS_IN_NAVIGATION.RELATED_PRODUCTS
        }
        case COMPONENTS_IN_NAVIGATION.CONJUGATES.DISPLAY_NAME: {
          return COMPONENTS_IN_NAVIGATION.CONJUGATES
        }
      }
    }

    const productListRef = usePDPNavigationObserver(() => {
      pdpStore.setActiveComponentInNavigation(getComponentInNavFromOnName(activeProductListTab.value).ANCHOR)
    })

    const displayCondition = ref(
      !!productListComponents.length &&
        activeProductListTab.value !== null &&
        currentProduct.data.attributes.statusDates.status !== PRODUCT_STATUS.DISCONTINUED
    )
    if (displayCondition.value) {
      pdpStore.setComponentAsRendered(getComponentInNavFromOnName(activeProductListTab.value))
    }

    onMounted(() => {
      productListTitle.forEach((value) => {
        if (
          value === COMPONENTS_IN_NAVIGATION.RELATED_PRODUCTS.DISPLAY_NAME &&
          currentProduct.data.recommendedProducts
        ) {
          trackProductListImpressions(
            currentProduct.data.recommendedProducts,
            COMPONENTS_IN_NAVIGATION.RELATED_PRODUCTS.DISPLAY_NAME
          )
        }
        if (value === COMPONENTS_IN_NAVIGATION.CONJUGATES.DISPLAY_NAME && currentProduct.data.conjugations) {
          trackProductListImpressions(
            currentProduct.data.conjugations,
            COMPONENTS_IN_NAVIGATION.CONJUGATES.DISPLAY_NAME
          )
        }
      })
    })

    return {
      displayCondition,
      COMPONENTS_IN_NAVIGATION,
      productListRef,
      currentProduct,
      productListTitle,
      activeProductListTab,
      productIncludesData,
      onTabChange,
      customProductIncludes,
      productIncludesDisplayCondition,
      isPreviewServer,
    }
  },
})
